import axios from "axios";

import endPoints from "../../../../config/endPoints";



// READ
export const getReceiptsApi = async(deptId, reqBody) => { 
  return await axios.post(`${endPoints.receiptTracking}/sorted/${deptId}`, reqBody);  
};

export const getUnsortedReceiptsApi = async(deptId, reqBody) => {
  
  return await axios.post(`${endPoints.receiptTracking}/search/${deptId}`, reqBody);  
};

export const getMasterReceiptsApi = async(deptId, reqBody) => { 
  return await axios.post(`${endPoints.receiptMaster}/search/${deptId}`, reqBody);  
};

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export const findReceiptsApi = async(deptId, reqBody) => {
  return await axios.post(`${endPoints.receiptTracking}/sorted/${deptId}`, reqBody);
};

export const generatePDFReport = async (reqBody) => {
  return await axios.post(`${endPoints.reports}/report`, reqBody);
};

// CREATE =>  POST: add a new receipt to the server
// export const createReceipt = async(receipt) => {
//   return axios.post(endPoints.receiptTracking, { receipt });
// }

// export const getReceiptById = async(receiptId) => {
//   await axios.get(`${endPoints.receiptTracking}/${receiptId}`);
// }


// UPDATE => PUT: update the customer on the server
// export const updateReceipt = async(receipt) => {
//   await axios.put(`${endPoints.receiptTracking}/${receipt.id}`, { receipt });
// }

// UPDATE Status
// export const updateStatusForReceipts = async(ids, status) => {
//   await axios.post(`${endPoints.receiptTracking}/updateStatusForReceipts`, {
//     ids,
//     status
//   });
// }

// DELETE => delete the receipt from the server
// export const deleteReceipt = async(receiptId) => {
//   await axios.delete(`${endPoints.receiptTracking}/${receiptId}`);
// }

// DELETE receipts by ids
// export const deleteReceipts = async(ids) => {
//   await axios.post(`${endPoints.receiptTracking}/deleteReceipts`, { ids });
// }
